export const selectShowDemoBanner = (state) => state.globalBanner.showDemoBanner
export const selectMailboxesSyncing = (state) => state.globalBanner.mailboxesSyncing
export const selectDiscoveryBanner = (state) => state.globalBanner.discoveryBanner
